import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  ChevronRight,
  Plus,
  X,
  BriefcaseBusiness,
  GraduationCap,
  Award,
  UserRound,
} from "lucide-react";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const HERO_IMAGE = "/assets/images/bg2.jpeg";


const managementTeam = [
  {
    id: 1,
    name: "Bamanga Usman Jada",
    role: "Managing Director / Chief Executive Officer",
    image: "/assets/images/md2.jpeg",
    summary:
      "A forward-thinking technocrat driving reforms aligned with Nigeria’s Renewed Hope Agenda in the oil and gas sector.",
    details: [
      "Bamanga Usman Jada is the Managing Director and Chief Executive Officer of the Oil and Gas Free Zones Authority (OGFZA), appointed in October 2023 by President Bola Ahmed Tinubu (GCFR).",
      "Upon assuming office, he introduced a strategic 7-Point roadmap focused on Efficiency and Trust, Infrastructure Excellence, Regulatory Modernization, Local Content Empowerment, Sustainability and Resilience, Investor-focus and Welfare.",
      "Under his leadership, OGFZA’s total attracted investment has ramped up to $30 billion and has facilitated ongoing projects capable of generating over 3 million direct and indirect jobs.",
      "He holds a Diploma in Business Administration and a B.Sc. in Economics from the Federal University of Technology, Yola; an M.Sc. in Oil and Gas Operations Management from the University of Central Lancashire, Preston, UK; and an MBA in Marketing from Nasarawa State University, Keffi.",
      "He is a member of the Chartered Institute of Logistics and Transport, UK, and a Fellow of the Chartered Institute of Diplomacy and Management.",
    ],
    awards: [
      "CEO of the Year 2024 – LEADERSHIP Media Group",
      "CEO of the Year 2024 – Blueprint Newspaper",
      "Distinguished GovTech Trailblazer Award – BPSR 2024",
      "Best Federal MDA in Ease of Doing Business Automation – BPSR 2024",
      "Distinguished Leadership in Nigerian Oil and Gas Free Zones 2024 – NOGFA",
      "Man of the Year and Excellence Award 2024 – Top 10 Magazine",
      "Excellence in Public Service Awards 2025 – BusinessDay Public Service Awards",
      "Distinguished Award of Excellence 2025 – Salvage Africa",
    ],
  },
  {
    id: 2,
    name: "Simon Ovbe Akpadaka",
    role: "General Manager, Finance Department",
    image: "/assets/images/simon-ovbe-akpadaka.png",
    summary:
      "A seasoned finance professional with over two decades of experience, predominantly in the oil and gas industry.",
    details: [
      "Simon Ovbe Akpadaka, FCA, is the General Manager in charge of the Finance Department at OGFZA.",
      "He holds an MSc in International Accounting and Finance from the University of Liverpool, UK, and an HND in Accounting from Lagos State Polytechnic.",
      "He also holds certificates in Financial Markets from Yale University and Digital Disruption: Digital Transformation Strategies from the University of Cambridge Judge Business School Executive Education.",
      "He is a Fellow of the Institute of Chartered Accountants of Nigeria, an ICAN Merit Award holder, and an alumnus of the Executive Education programme at Harvard Kennedy School.",
      "His career spans both private and public sectors, including leadership roles in Internal Audit, Warri Free Zone, and Lagos Office.",
    ],
    awards: ["Fellow, Institute of Chartered Accountants of Nigeria", "ICAN Merit Award Holder"],
  },
  {
    id: 3,
    name: "Adamu Mamman Kontagora",
    role: "General Manager / HOD, Trade and Investment",
    image: "/assets/images/adamu-mamman-kontagora.png",
    summary:
      "A trade and investment professional with extensive public service and investment promotion experience.",
    details: [
      "Adamu Mamman Kontagora is the General Manager and Head of Department, Trade and Investment.",
      "He is a graduate of Ahmadu Bello University, Zaria.",
      "He worked in the public service for six years before joining OGFZA.",
      "He has attended and presented papers at many local and international conferences, exhibitions, trade seminars, and investment forums.",
      "He was part of the effort that brought the international conference on Practical Local Content by the UK group CWC to Onne, Rivers State, in 2010.",
    ],
    awards: [],
  },
  {
    id: 4,
    name: "Ivuoma Michael Okoro",
    role: "General Manager / HOD, Policy, Planning, Research and Statistics",
    image: "/assets/images/ivuoma-michael-okoro.png",
    summary:
      "A policy, planning, research, statistics, and human resource professional with strong administrative experience.",
    details: [
      "Mrs. Ivuoma Michael Okoro is the General Manager and Head of Department, Policy, Planning, Research and Statistics Department.",
      "She has served in the Legal Department / Board Secretariat and the Human Resources Unit of the Administration Department.",
      "She holds a Professional Diploma in Human Resource Management from CIPM, a Post Graduate Diploma in Management from the University of Calabar, a B.Sc. in Business Education from the University of Nigeria, Nsukka, and an NCE in Business Studies from Alvan Ikoku College of Education.",
      "Before joining OGFZA in 2004, she worked with Intels Nigeria Limited, Pauliza Computers, Ujamma Consultants Ltd., and Nigerian Bottling Company.",
      "She is an Associate of the Chartered Institute of Personnel Management.",
    ],
    awards: ["Associate, Chartered Institute of Personnel Management"],
  },
  {
    id: 5,
    name: "Cynthia Eguridu",
    role: "Chief Operating Officer, Freezone Global Investments Limited",
    image: "/assets/images/cynthia-eguridu.jpg",
    summary:
      "An investment, policy, commercial law, and development professional leading OGFZA’s SPV operations.",
    details: [
      "Mrs. Cynthia Eguridu is the Chief Operating Officer of Freezone Global Investments Limited, the investment management and commercial subsidiary of OGFZA.",
      "She is a member of the Harvard University alumnus community with an Executive Certificate in Public Policy.",
      "She holds an LLM in International Commercial Law from the University of Salford, England; an MBA from London School of Business and Finance; an M.A. in Marketing and Communications; and B.A. and M.Sc. degrees in Economics from the University of Leicester.",
      "She previously managed a business consultancy and advisory firm in London before being headhunted by the Securities and Exchange Commission Nigeria to serve as Special Adviser to the Director General.",
      "She has held investment advisory roles for African governments including Sierra Leone, Uganda, Rwanda, and Nigeria.",
    ],
    awards: [
      "Entrepreneur of the Year – AWIB United Kingdom",
      "UK Individual Merit Award for Outstanding Performance",
      "Life Member, SUNTUK Think Tank",
    ],
  },
  {
    id: 6,
    name: "Ideriah Victor Stanley K.",
    role: "Deputy General Manager / HOD, Administration",
    image: "/assets/images/ideriah-victor-stanley.jpg",
    summary:
      "An experienced administrator responsible for overseeing administrative systems and institutional operations.",
    details: [
      "Mr. Ideriah Victor Stanley K. is the Deputy General Manager and Head of the Department of Administration at OGFZA.",
      "He oversees administrative functions and ensures smooth administrative processes within the organization.",
      "He holds a B.Sc. degree in Business Administration with a marketing option from Rivers State University.",
      "He is a Fellow of Global Peace and Conflict Management, an alumnus of the Washington School of Protocol, and an Associate Member of the Institute of Strategic Management of Nigeria.",
      "He has served as Protocol Officer at Rivers State Government House, Chief Protocol Officer at Rivers State House of Assembly, First Head of Protocol at OGFZA, Head of Public Affairs Unit, Head of Heliconia Park, and Head of Facility Management at OGFZA.",
    ],
    awards: [
      "Fellow, Global Peace and Conflict Management",
      "Associate Member, Institute of Strategic Management of Nigeria",
    ],
  },
  {
    id: 7,
    name: "Mrs. Ekeh, Constance Awelechukwu",
    role: "Deputy General Manager / HOD, Operations and Technical Services",
    image: "/assets/images/constance-ekeh.png",
    summary:
      "A logistics, operations, procurement, and technical services professional with extensive OGFZA experience.",
    details: [
      "Mrs. Ekeh Constance Awelechukwu is the Deputy General Manager and Head of Operations and Technical Services at OGFZA.",
      "She holds an HND in Mass Communication from Federal Polytechnic Oko, a Postgraduate Diploma in Marketing from the University of Calabar, a B.Sc. in Management from the University of Science and Technology, Port Harcourt, and an MBA in Management from the University of Calabar.",
      "She began her career in insurance at Niger Insurance Company before moving into logistics when she joined OGFZA in 2001.",
      "At OGFZA, she rose through the ranks from Marketing Officer to Credit Control Officer, Manager Invoicing Unit, Head Budget Unit, Assistant General Manager Operations, and Head of Operations and Technical Services.",
      "She also holds a Micro Master’s in Procurement from Malaysia University and certifications in international trade logistics and procurement.",
    ],
    awards: [
      "Certified International Trade Logistics Specialist",
      "Certified International Trade Logistics Manager",
      "Certified Procurement Manager",
      "Fellow, Nigerian Institute of Shipping",
      "Fellow, African Centre for Supply Chain",
      "Platinum Fellow, Institute of Leadership Manpower Development, UK",
      "Honorary Doctorate in Transformational Leadership, Social Works and Community Development",
    ],
  },
  {
    id: 8,
    name: "Momoh Sani Shaibu",
    role: "AGM / HOD, Registry",
    image: "/assets/images/momoh-sani-shaibu.png",
    summary:
      "A legal and registry services professional with experience in law, legislation, procurement, and investment promotion.",
    details: [
      "Momoh Sani Shaibu is the Assistant General Manager and Head of Registry at OGFZA.",
      "He holds a Bachelor of Laws degree from Bayero University Kano and was called to the Nigerian Bar in 2000.",
      "He began his career as a private legal practitioner at En-consult Engineering Firm in Kano, where he served as company secretary, before moving to Diko and Mahmood Law Firm.",
      "He later served as Senior Legislative Aide at the National Assembly Service Commission before joining OGFZA in 2009.",
      "He is a member of the Nigerian Bar Association and has obtained certificates in management and leadership training, trade and investment promotion, advanced procurement management, and ease of doing business.",
    ],
    awards: ["Member, Nigerian Bar Association"],
  },
  {
    id: 9,
    name: "Igbiks Tamunoseipiriye, Esq.",
    role: "Principal Manager / HOD, Legal Services and Board Secretary",
    image: "/assets/images/igbiks-tamunoseipiriye.png",
    summary:
      "A legal practitioner and board secretariat professional overseeing legal services at OGFZA.",
    details: [
      "Igbiks Tamunoseipiriye, Esq. is the Principal Manager and Head of Legal Services, as well as the Governing Board Secretary of OGFZA.",
      "He obtained his LL.B from Nnamdi Azikiwe University, Awka, and proceeded to the Nigerian Law School, Abuja, after which he was called to the Nigerian Bar in 2004.",
      "He began his professional career at P. Nwankwoala and Co., where he practiced for over a decade before joining OGFZA in 2016 as a Manager in the Legal Department.",
      "At OGFZA, he served in different capacities, including Senior Legal Officer with the Special Purpose Vehicle Department, before being appointed HOD of Legal / Board Secretariat in 2025.",
      "He is a professional fellow/member of the Nigerian Bar Association and Okrika Born Lawyers.",
    ],
    awards: ["Member, Nigerian Bar Association", "Member, Okrika Born Lawyers"],
  },
];

const MemberCard = ({ member, onOpen }) => (
  <article className="member-card group relative w-full max-w-[340px] h-[430px] bg-white overflow-hidden rounded-[28px] shadow-[0_22px_60px_rgba(2,107,7,0.16)] border border-slate-100">
    <img
      src={member.image}
      alt={member.name}
      className="absolute inset-0 w-full h-full object-cover object-top transition-all duration-700 group-hover:scale-105"
      onError={(e) => {
        e.currentTarget.src = "/assets/images/placeholder-user.jpg";
      }}
    />

    <div className="absolute inset-0 bg-gradient-to-t from-[#020617]/95 via-[#020617]/50 to-transparent" />

    <div className="absolute top-5 left-5">
      <span className="inline-flex items-center gap-2 rounded-full bg-white/95 px-4 py-2 text-[11px] font-black uppercase tracking-[0.18em] text-[#026b07]">
        <UserRound size={14} />
        OGFZA
      </span>
    </div>

    <div className="absolute left-6 right-6 bottom-[86px] text-white">
      <h3
        className="text-[21px] md:text-[24px] font-black leading-tight"
        style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
      >
        {member.name}
      </h3>

      <p className="text-[13px] text-white/85 mt-2 leading-relaxed">
        {member.role}
      </p>
    </div>

    <button
      onClick={() => onOpen(member)}
      aria-label={`View profile of ${member.name}`}
      className="absolute left-0 bottom-0 h-[58px] w-[128px] bg-[#f2af11] flex items-center justify-center text-[#201182] hover:bg-[#026b07] hover:text-white transition-colors"
      style={{
        clipPath: "polygon(0 0, 100% 0, 88% 100%, 0 100%)",
      }}
    >
      <span className="w-9 h-9 rounded-full bg-white text-[#201182] flex items-center justify-center shadow-lg">
        <Plus size={19} strokeWidth={3} />
      </span>
    </button>

    <button
      onClick={() => onOpen(member)}
      className="absolute right-5 bottom-5 text-[12px] font-black uppercase tracking-[0.14em] text-white/90 hover:text-[#f2af11] transition-colors"
    >
      View Profile
    </button>
  </article>
);

const MemberModal = ({ member, onClose }) => {
  if (!member) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-[999] bg-[#020617]/85 backdrop-blur-sm flex items-center justify-center p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-6xl bg-white rounded-[30px] shadow-[0_30px_100px_rgba(0,0,0,0.45)] overflow-hidden max-h-[92vh] grid lg:grid-cols-[390px_1fr]"
      >
        <button
          onClick={onClose}
          aria-label="Close profile modal"
          className="absolute top-4 right-4 z-20 w-11 h-11 rounded-full bg-white text-[#201182] hover:bg-[#f2af11] hover:text-white flex items-center justify-center shadow-xl transition-colors"
        >
          <X size={20} />
        </button>

        <aside className="relative min-h-[360px] lg:min-h-full bg-[#020617] overflow-hidden">
          <img
            src={member.image}
            alt={member.name}
            className="absolute inset-0 w-full h-full object-cover object-top opacity-90"
            onError={(e) => {
              e.currentTarget.src = "/assets/images/placeholder-user.jpg";
            }}
          />

          <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/45 to-transparent" />

          <div className="absolute left-7 right-7 bottom-7 text-white">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#f2af11] px-4 py-2 text-[11px] font-black uppercase tracking-[0.18em] text-[#201182] mb-4">
              Management Profile
            </span>

            <h3
              className="text-3xl font-black leading-tight"
              style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
            >
              {member.name}
            </h3>

            <p className="mt-3 text-white/85 text-sm leading-relaxed">
              {member.role}
            </p>
          </div>
        </aside>

        <section className="max-h-[92vh] overflow-y-auto custom-modal-scroll">
          <div className="p-7 md:p-10 lg:p-12">
            <div className="mb-8">
              <p className="text-[#026b07] font-black uppercase tracking-[0.22em] text-xs mb-3">
                Executive Biography
              </p>

              <h2
                className="text-3xl md:text-5xl font-black text-[#201182] leading-tight"
                style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
              >
                {member.name}
              </h2>

              <p className="mt-4 text-slate-600 text-[16px] leading-relaxed max-w-3xl">
                {member.summary}
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-4 mb-9">
              <div className="rounded-2xl bg-[#026b07]/10 border border-[#026b07]/15 p-5">
                <BriefcaseBusiness className="text-[#026b07] mb-3" size={24} />
                <p className="text-xs uppercase tracking-widest font-black text-slate-500">
                  Position
                </p>
                <p className="mt-2 text-sm font-bold text-slate-800 leading-relaxed">
                  {member.role}
                </p>
              </div>

              <div className="rounded-2xl bg-[#201182]/10 border border-[#201182]/15 p-5">
                <GraduationCap className="text-[#201182] mb-3" size={24} />
                <p className="text-xs uppercase tracking-widest font-black text-slate-500">
                  Profile
                </p>
                <p className="mt-2 text-sm font-bold text-slate-800 leading-relaxed">
                  Leadership, administration, regulation and sector development.
                </p>
              </div>

              <div className="rounded-2xl bg-[#f2af11]/20 border border-[#f2af11]/30 p-5">
                <Award className="text-[#b97800] mb-3" size={24} />
                <p className="text-xs uppercase tracking-widest font-black text-slate-500">
                  Recognition
                </p>
                <p className="mt-2 text-sm font-bold text-slate-800 leading-relaxed">
                  Professional service, institutional leadership and public sector impact.
                </p>
              </div>
            </div>

            <div className="space-y-5">
              {member.details.map((item, index) => (
                <p
                  key={index}
                  className="text-slate-700 leading-[1.9] text-[15px] md:text-[16px]"
                >
                  {item}
                </p>
              ))}
            </div>

            {member.awards.length > 0 && (
              <div className="mt-10 rounded-[24px] bg-slate-50 border border-slate-200 p-6 md:p-8">
                <h4
                  className="text-2xl font-black text-[#201182] mb-5"
                  style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
                >
                  Awards, Memberships & Recognitions
                </h4>

                <div className="grid sm:grid-cols-2 gap-3">
                  {member.awards.map((award, index) => (
                    <div
                      key={index}
                      className="flex gap-3 rounded-2xl bg-white p-4 border border-slate-100 shadow-sm"
                    >
                      <span className="mt-1 w-2.5 h-2.5 rounded-full bg-[#f2af11] shrink-0" />
                      <p className="text-sm text-slate-700 font-semibold leading-relaxed">
                        {award}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>
      </div>

      <style>{`
        .custom-modal-scroll::-webkit-scrollbar {
          width: 9px;
        }

        .custom-modal-scroll::-webkit-scrollbar-track {
          background: #f1f5f9;
        }

        .custom-modal-scroll::-webkit-scrollbar-thumb {
          background: #201182;
          border-radius: 999px;
        }

        .custom-modal-scroll::-webkit-scrollbar-thumb:hover {
          background: #026b07;
        }
      `}</style>
    </div>
  );
};

const ManagementTeam = () => {
  const [selected, setSelected] = useState(null);
  const pageRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".hero-badge", {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: "power3.out",
      });

      gsap.from(".hero-title", {
        opacity: 0,
        y: 80,
        duration: 1.1,
        ease: "power4.out",
      });

      gsap.from(".hero-text", {
        opacity: 0,
        y: 40,
        duration: 0.9,
        delay: 0.25,
        ease: "power3.out",
      });

      gsap.from(".member-card", {
        opacity: 0,
        y: 45,
        duration: 0.9,
        stagger: 0.08,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".members-grid",
          start: "top 85%",
        },
      });

      gsap.to(".hero-orb-one", {
        y: 40,
        x: -25,
        repeat: -1,
        yoyo: true,
        duration: 6,
        ease: "sine.inOut",
      });

      gsap.to(".hero-orb-two", {
        y: -35,
        x: 25,
        repeat: -1,
        yoyo: true,
        duration: 7,
        ease: "sine.inOut",
      });
    }, pageRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    if (selected) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [selected]);

  return (
    <main ref={pageRef}>
      <section className="relative bg-white pb-24 overflow-hidden">
        <div className="relative min-h-[640px] bg-[#020617] pt-28 pb-52 md:pb-60 overflow-hidden">
          <img
            src={HERO_IMAGE}
            alt="OGFZA Management Team"
            className="absolute inset-0 w-full h-full object-cover"
          />

          <div className="absolute inset-0 bg-[#020617]/80" />

          <div className="absolute inset-0 bg-gradient-to-br from-[#201182]/95 via-[#026b07]/75 to-[#f2af11]/35" />

          <div className="hero-orb-one absolute -top-24 -left-24 w-[460px] h-[460px] rounded-full bg-[#026b07]/35 blur-3xl" />

          <div className="hero-orb-two absolute -bottom-28 -right-24 w-[460px] h-[460px] rounded-full bg-[#f2af11]/30 blur-3xl" />

          <div className="absolute inset-0 opacity-[0.08] bg-[linear-gradient(to_right,#fff_1px,transparent_1px),linear-gradient(to_bottom,#fff_1px,transparent_1px)] bg-[size:80px_80px]" />

          <div className="relative max-w-7xl mx-auto px-6 text-center">
            <div className="hero-badge inline-flex items-center gap-3 mb-5">
              <span className="w-10 h-[3px] bg-[#f2af11]" />

              <span className="text-[#f2af11] font-bold tracking-[0.2em] text-sm uppercase">
                Leadership
              </span>
            </div>

            <h1
              className="hero-title text-5xl md:text-7xl lg:text-[82px] font-black text-white leading-[1.02]"
              style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
            >
              Management Team
            </h1>

            <p className="hero-text text-white/85 max-w-3xl mx-auto mt-6 leading-relaxed text-[17px]">
              Meet the professionals providing strategic direction,
              institutional leadership, regulatory oversight, and operational
              excellence across the Oil and Gas Free Zones Authority.
            </p>

            <div className="hero-text flex items-center justify-center gap-2 mt-6 text-sm text-white/80 flex-wrap">
              <Link to="/" className="hover:text-[#f2af11] transition-colors">
                Home
              </Link>

              <ChevronRight size={14} />

              <Link
                to="/about"
                className="hover:text-[#f2af11] transition-colors"
              >
                About Us
              </Link>

              <ChevronRight size={14} />

              <span className="text-[#f2af11]">Management Team</span>
            </div>
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 -mt-36 md:-mt-44 z-10">
          <div className="members-grid flex flex-wrap justify-center gap-7">
            {managementTeam.map((member) => (
              <MemberCard
                key={member.id}
                member={member}
                onOpen={setSelected}
              />
            ))}
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-6 mt-20 text-center">
          <p className="text-[#026b07] font-black uppercase tracking-[0.2em] text-xs mb-3">
            Institutional Leadership
          </p>

          <h2
            className="text-3xl md:text-5xl font-black text-[#201182] leading-tight"
            style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
          >
            Steering OGFZA’s regulatory and investment mandate
          </h2>

          <p className="mt-5 text-slate-600 leading-relaxed">
            The management team supports OGFZA’s mission to promote, secure and
            sustain investments in Nigeria’s oil and gas free zones through
            sound administration, investor support, regulatory modernization,
            policy execution and operational excellence.
          </p>
        </div>
      </section>

      <MemberModal member={selected} onClose={() => setSelected(null)} />
    </main>
  );
};

export default ManagementTeam;